import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  useDataProvider,
  Toolbar,
  SaveButton,
} from 'react-admin';
import { Box } from '@mui/material';
import ProductsFormFields from '../customForms/ProductsFormFields';

const CustomToolbar = props => (
  <Toolbar
    {...props}
    sx={{
      position: 'sticky',
      bottom: 0,
      zIndex: 100,
      backgroundColor: 'background.paper',
      borderTop: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      justifyContent: 'flex-start',
      px: 2,
      py: 1.5,
    }}
  >
    <SaveButton />
  </Toolbar>
);

const ProductsCreate = () => {
  const dataProvider = useDataProvider();
  const [allConfigs, setAllConfigs] = useState([]);
  const [allRecipes, setAllRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const [configsRes, recipesRes] = await Promise.all([
          dataProvider.getList('configs', {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'Name', order: 'ASC' },
            filter: {},
          }),
          dataProvider.getList('recipes', {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'Name', order: 'ASC' },
            filter: {},
          }),
        ]);
        setAllConfigs(configsRes.data);
        setAllRecipes(recipesRes.data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch configs or recipes:', err);
      }
    };

    fetchLists();
  }, [dataProvider]);

  if (loading) return <p>Loading...</p>;

  return (
    <Create title="Novo Produto" redirect="edit"
      transform={(data) => ({
        name: data.Name,
        configID: data.Config,
        recipeIDs: data.Recipes,
      })}
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <ProductsFormFields allConfigs={allConfigs} allRecipes={allRecipes} />
      </SimpleForm>
    </Create>
  );
};

export default ProductsCreate;
